import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { OnboardingLayout } from "@/components/layout/OnboardingLayout";
import { BackToEllie } from "@/components/companion/BackToEllie";
import { journey } from "@/lib/journey";
import { saveJourneyProgress } from "@/services/unsaidService";
import { GuestSaveBanner } from "@/components/journey/GuestSaveBanner";

export const JOURNEY_PATHS = ["/the-unsaid", "/the-unsaid/reveal", "/emotional-xray", "/today-plan", "/future-self", "/purpose"];

// Gate paid routes on SERVER-verified entitlement (never local state alone). A free account's one active
// guided journey may open the journey steps; the server enforces that allowance on every AI call too.
export default function RequireSubscriber({ children }) {
  const { user, loading } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const checking = loading || user === undefined;
  const onJourney = journey.isOn() && JOURNEY_PATHS.includes(pathname);
  const guestOk = !user && onJourney && !!journey.guestId();
  const journeyOk = guestOk || (!!user && !user.entitled && onJourney && (user.journey_status === "active" || !!journey.guestId()));
  const redirectTo = !checking ? (!user ? (guestOk ? null : onJourney || journey.guestId() ? "/journey" : "/login") : user.entitled || journeyOk ? null
    : user.journey_status === "completed" ? "/journey/complete" : user.journey_status ? "/journey" : user.has_discovery ? "/discovery/reveal#trial" : "/") : null;

  useEffect(() => {
    if (redirectTo) navigate(redirectTo, { replace: true });
    else if (journeyOk) {
      journey.setStep(pathname);
      saveJourneyProgress(pathname, journey.snapshot());
    }
  }, [redirectTo, navigate, journeyOk, pathname]);

  if (checking || redirectTo) {
    return (
      <OnboardingLayout testId="page-guard-loading" contentClassName="items-center justify-center py-10 text-center">
        <div className="flex items-center gap-1.5">
          {[0, 1, 2].map((i) => (<span key={i} className="h-2.5 w-2.5 animate-bounce rounded-full bg-primary/60" style={{ animationDelay: `${i * 0.15}s` }} />))}
        </div>
      </OnboardingLayout>
    );
  }
  return <>{guestOk && <GuestSaveBanner />}{children}{!journeyOk && <BackToEllie />}</>;
}
